import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["prevButton", "nextButton", "navTabs"]
  static values = {
    query: Object,
    rowId: String,
    frameSelector: { type: String, default: "turbo-frame#hotwire-modal-content" }
  }

  static ACTIVE_TAB_STORAGE_KEY = "logs-modal-navigation-active-tab"

  connect() {
    if (this.hasQueryValue) {
      this.queryStr = `?${new URLSearchParams(this.queryValue)}`
    }

    this.updateNavigationButtons()
    this.restoreActiveTab()
    this.boundKeyHandler = this.handleKeyPress.bind(this)
    document.addEventListener("keydown", this.boundKeyHandler)
  }

  disconnect() {
    this.saveActiveTab()
    if (this.boundKeyHandler) {
      document.removeEventListener("keydown", this.boundKeyHandler)
    }
  }

  updateNavigationButtons() {
    const currentRow = this.getCurrentRow()
    
    if (!currentRow) {
      this.hideAllButtons()
      return
    }

    const prevRow = currentRow.previousElementSibling
    if (prevRow?.dataset.logModalUrl && this.hasPrevButtonTarget) {
      this.showButton(this.prevButtonTarget)
    } else if (this.hasPrevButtonTarget) {
      this.hideButton(this.prevButtonTarget)
    }

    const nextRow = currentRow.nextElementSibling
    if (nextRow?.dataset.logModalUrl && this.hasNextButtonTarget) {
      this.showButton(this.nextButtonTarget)
    } else if (this.hasNextButtonTarget) {
      this.hideButton(this.nextButtonTarget)
    }
  }

  showLast(event) {
    if (event) event.preventDefault()
    const currentRow = this.getCurrentRow()
    const prevRow = currentRow?.previousElementSibling
    
    if (prevRow?.dataset.logModalUrl) {
      const frame = this.getTurboFrame()
      if (frame) {
        frame.setAttribute("src", this.expandUrl(prevRow.dataset.logModalUrl))
      }
    }
  }

  showNext(event) {
    if (event) event.preventDefault()
    const currentRow = this.getCurrentRow()
    const nextRow = currentRow?.nextElementSibling
    
    if (nextRow?.dataset.logModalUrl) {
      const frame = this.getTurboFrame()
      if (frame) {
        frame.setAttribute("src", this.expandUrl(nextRow.dataset.logModalUrl))
      }
    }
  }

  getCurrentRow() {
    return document.getElementById(this.rowIdValue)
  }

  getTurboFrame() {
    return document.querySelector(this.frameSelectorValue)
  }

  expandUrl(url) {
    if (this.queryStr === undefined) {
      return url
    }

    return `${url}${this.queryStr}`
  }

  saveActiveTab() {
    if (!this.hasNavTabsTarget) return

    const activeTab = this.getActiveTabLink()
    if (activeTab && activeTab.hash) {
      sessionStorage.setItem(this.constructor.ACTIVE_TAB_STORAGE_KEY, activeTab.hash)
    }
  }

  restoreActiveTab() {
    if (!this.hasNavTabsTarget) return

    const savedTab = sessionStorage.getItem(this.constructor.ACTIVE_TAB_STORAGE_KEY)
    if (savedTab) {
      const tabLink = this.getTabLink(savedTab)
      if (tabLink) {
        $(tabLink).tab("show")
      }
    }
  }

  getActiveTabLink() {
    return this.navTabsTarget.querySelector("li.active a")
  }

  getTabLink(href) {
    return this.navTabsTarget.querySelector(`a[href="${href}"]`)
  }

  showButton(button) {
    button.style.visibility = "visible"
  }

  hideButton(button) {
    button.style.visibility = "hidden"
  }

  hideAllButtons() {
    if (this.hasPrevButtonTarget) {
      this.hideButton(this.prevButtonTarget)
    }
    if (this.hasNextButtonTarget) {
      this.hideButton(this.nextButtonTarget)
    }
  }

  handleKeyPress(event) {
    if (event.target.matches("input, textarea, select")) return

    switch(event.key) {
    case "ArrowUp":
      if (this.hasPrevButtonTarget && this.prevButtonTarget.style.visibility === "visible") {
        event.preventDefault()
        this.prevButtonTarget.click()
      }
      break
    case "ArrowDown":
      if (this.hasNextButtonTarget && this.nextButtonTarget.style.visibility === "visible") {
        event.preventDefault()
        this.nextButtonTarget.click()
      }
      break
    }
  }
}
